// src/i18n/es/lockerTypes.js
const lockerTypes = {
    name: 'Tipo de Taquilla |||| Tipos de Taquillas',
    titles: {
        list: 'Tipos de Taquillas',
        create: 'Crear Tipo de Taquilla',
        edit: 'Editar Tipo de Taquilla',
        show: 'Detalles del Tipo de Taquilla'
    },
    fields: {
        name: 'Nombre del Tipo',
        description: 'Descripción',
        hotel: 'Hotel',
        createdAt: 'Fecha de Creación',
        updatedAt: 'Última Actualización'
    },
    actions: {
        create: 'Crear Nuevo Tipo',
        edit: 'Editar',
        delete: 'Eliminar',
        save: 'Guardar',
        cancel: 'Cancelar'
    },
    sections: {
        details: 'Detalles del Tipo de Taquilla',
        new_type_title: 'Nuevo Tipo de Taquilla',
        new_type_subtitle: 'Configure los detalles para el nuevo tipo de taquilla'
    },
    filters: {
        search: 'Buscar tipos de taquillas...'
    },
    messages: {
        no_types: 'No hay tipos de taquillas disponibles',
        no_types_description: 'No se encontraron tipos de taquillas. Puede crear uno nuevo haciendo clic en el botón "Crear".',
        access_denied: 'No tiene permisos para ver los tipos de taquillas',
        update_success: 'Tipo de taquilla actualizado con éxito',
        update_error: 'Error al actualizar el tipo de taquilla'
    },
    notifications: {
        created: 'Tipo de taquilla creado con éxito',
        updated: 'Tipo de taquilla actualizado con éxito',
        deleted: 'Tipo de taquilla eliminado con éxito'
    },
    errors: {
        create: 'Error al crear el tipo de taquilla',
        update: 'Error al actualizar el tipo de taquilla',
        delete: 'Error al eliminar el tipo de taquilla',
        fetch: 'Error al cargar los tipos de taquillas'
    },
    dialogs: {
        delete_title: 'Eliminar Tipo de Taquilla',
        delete_message: '¿Está seguro de que desea eliminar este tipo de taquilla?',
        delete_warning: 'Esta acción no se puede deshacer. Se eliminará permanentemente el tipo de taquilla.',
        unsaved_changes: 'Cambios sin guardar',
        unsaved_changes_message: 'Tiene cambios sin guardar. ¿Desea guardarlos antes de continuar?'
    },
    validation: {
        name_required: 'El nombre es obligatorio (mín. 2 caracteres)',
        name_max_length: 'El nombre no puede exceder los 100 caracteres',
        description_max_length: 'La descripción no puede exceder los 500 caracteres',
        hotel_required: 'Debe seleccionar un hotel'
    }
};

export default lockerTypes;
